import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import { clearRegistrationBackendError } from '../../data/actions';
import messages from '../../messages';
import { validateProfessionType } from './validator';

import { Form, Icon } from '@openedx/paragon';
import { ExpandMore } from '@openedx/paragon/icons';
import { PROFESSION_TYPES } from '../../../register/data/constants';

const ProfessionTypeField = ({
  value,
  handleChange,
  handleErrorChange,
  errorMessage,
}) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const handleOnBlur = (e) => {
    const error = validateProfessionType(e.target.value, formatMessage, messages);
    handleErrorChange('profession_type', error);
  };

  const handleOnFocus = () => {
    handleErrorChange('profession_type', '');
    dispatch(clearRegistrationBackendError('profession_type'));
  };

  return (
    <Form.Group controlId="profession_type" isInvalid={!!errorMessage}>
      <Form.Control
        as="select"
        name="profession_type"
        value={value}
        aria-invalid={!!errorMessage}
        onChange={handleChange}
        onBlur={handleOnBlur}
        onFocus={handleOnFocus}
        floatingLabel={formatMessage(messages['registration.profession.label'])}
        trailingElement={<Icon src={ExpandMore} />}
      >
        <option key="default" value="" disabled>
          -- Select your profession --
        </option>
        <option value={PROFESSION_TYPES.TEACHER}>Teacher</option>
        <option value={PROFESSION_TYPES.MHP_CREATIVE_ARTS_THERAPIST}>MHP Creative Arts Therapist</option>
        <option value={PROFESSION_TYPES.MHP_MARRIAGE_FAMILY_THERAPIST}>MHP Marriage and Family Therapist</option>
        <option value={PROFESSION_TYPES.MHP_MENTAL_HEALTH_COUNSELOR}>MHP Mental Health Counselors</option>
        <option value={PROFESSION_TYPES.PSYCHOANALYST}>Psychoanalyst</option>
        <option value={PROFESSION_TYPES.RN_NURSE_PRACTITIONER}>RN/Nurse Practitioner</option>
        <option value={PROFESSION_TYPES.DENTIST}>Dentist</option>
        <option value={PROFESSION_TYPES.DENTAL_HYGIENIST}>Dental Hygienist</option>
        <option value={PROFESSION_TYPES.OPTOMETRY}>Optometry</option>
        <option value={PROFESSION_TYPES.MEDICINE}>Medicine</option>
        <option value={PROFESSION_TYPES.ATHLETIC_TRAINING}>Athletic Training</option>
        <option value={PROFESSION_TYPES.PODIATRY}>Podiatry</option>
        <option value={PROFESSION_TYPES.PSYCHOLOGY}>Psychology</option>
        <option value={PROFESSION_TYPES.CHIROPRACTIC}>Chiropractic</option>
        <option value={PROFESSION_TYPES.LICENSED_BEHAVIOR_ANALYST}>Licensed Behavior Analyst</option>
        <option value={PROFESSION_TYPES.LMSW}>Licensed Master Social Worker</option>
        <option value={PROFESSION_TYPES.LCSW}>Licensed Clinical Social Worker</option>
        <option value={PROFESSION_TYPES.CBAA}>Certified Behavior Analyst Assistant</option>
        <option value={PROFESSION_TYPES.RESTRICTED_DENTAL_FACULTY}>Restricted Dental Faculty</option>
        <option value={PROFESSION_TYPES.OTHER}>Other</option>
      </Form.Control>

      {errorMessage && (
        <Form.Control.Feedback
          id="profession_type-error"
          type="invalid"
          className="form-text-size"
          hasIcon={false}
        >
          {errorMessage}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

ProfessionTypeField.defaultProps = {
  errorMessage: '',
};

ProfessionTypeField.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

export default ProfessionTypeField;
